define([
    './vendor/jquery',
    'imagesloaded',
    'isotope-layout',
    'isotope-packery',
], function($, imagesLoaded, Isotope, packery) {
    'use strict';

    var isoGrid;
    var dObj = {
        resized: false,
        centerVertically: false,
        breakpointXS: '480',
        breakpointSM: '768',
        breakpointMD: '1024',
        breakpointLG: '1681',
        orientation: window.orientation,
        lastOrientation: "",
        breakpoint: "breakpoint-md",
        initialCountrySelect: "false",
        initialCountryClick: "false",
        allowedMaxUploadSize: 5242880,
        chartInstances: [],
        helpers: {
            getBreakpoint: function () {
                dObj.mqEnabled = Modernizr.mq("only all");
                if (!dObj.mqEnabled) {
                    return;
                }
                if (Modernizr.mq('only all and (max-width: ' + (dObj.breakpointSM - 1) + 'px)')) {
                    dObj.breakpoint = "breakpoint-xs";
                } else if (Modernizr.mq('only all and (min-width: ' + dObj.breakpointSM + 'px) and (max-width: ' + (dObj.breakpointMD - 1) + 'px)')) {
                    dObj.breakpoint = "breakpoint-sm";
                } else if (Modernizr.mq('only all and (min-width: ' + dObj.breakpointMD + 'px) and (max-width: ' + (dObj.breakpointLG - 1) + 'px)')) {
                    dObj.breakpoint = "breakpoint-md";
                } else {
                    dObj.breakpoint = "breakpoint-lg";
                }
                if (dObj.breakpointWas === '') {
                    dObj.breakpointWas = dObj.breakpoint;
                } else if (dObj.breakpointWas !== dObj.breakpoint) {
                    $(document).trigger('breakpointchange', [dObj.breakpointWas, dObj.breakpoint]);
                    dObj.breakpointWas = dObj.breakpoint;
                }
                return dObj.breakpoint;
            },
            readDeviceOrientation: function () {
//alert("rotation: " + window.orientation);
                dObj.orientation = window.orientation;
                if (dObj.debug) {
                    if ($(".debug").length < 1) {
                        $(".page-intro").append("<div class='debug'><h4>Debug: </h4><span class='debug-message'></span></div>");
                    }
                    $(".debug-message").text(orientation);
                }
//prevent closing of offcanvas nav on smartphone screen
                var reloadOffcanvas = (dObj.breakpoint !== "breakpoint-xs");
//alert("reload: " + reloadOffcanvas);
                onBreakpointChange(reloadOffcanvas);
                dObj.lastOrientation = dObj.orientation;
                /*$('body').hide();
setTimeout(function() {
$('body').show();
}, 0);*/
            },
            showVersionInfo: function () {
                var domainString = "daimler_relaunch_staging";
                var currentDomain = window.location.pathname;
                var staging = (currentDomain.indexOf(domainString) !== -1);
                /*var d = new Date()
var curDate = "Datum: " + d.getDate();
curDate += "."+(d.getMonth()+1);
curDate += "."+d.getFullYear();*/
                if (staging) {
                    var curDate = dObj.deployDate;
                    var debugHtml = '<div class="version"><p class="version-date">Datum: ' + curDate + '</p><p class="version-number">Version: ' + dObj.version + '</p></div>';
                    $("body").prepend(debugHtml);
                    $(".version").show();
                } else {
                    $(".version").hide();
                }
            },
            cookieEnabled: function () {
                var cookieEnabled = (navigator.cookieEnabled) ? true : false;
                if (typeof navigator.cookieEnabled == "undefined" && !cookieEnabled) {
                    document.cookie = "testcookie";
                    cookieEnabled = (document.cookie.indexOf("testcookie") != -1) ? true : false;
                }
//alert('cookies enabled -> '+cookieEnabled);
                return (cookieEnabled);
            },
            reflowFixedPositions: function () {
                document.documentElement.style.paddingRight = '1px';
                setTimeout(function () {
                    document.documentElement.style.paddingRight = '';
                }, 0);
            },
            positionSliderArrows: function (options) {
                /*
* params:
* sliderContainerClass: parent elem to traverse from measured element to arrow wrapper
* assetContainerClass: wrapper of image which can be measured to position arrows centered
* controlWrapper: wrapper element of arrows
* arrowHeight: height to subtract half height from top positioning
*/
                var defaults = {
                    sliderContainerObj: "",
                    sliderContainerClass: "",
                    assetContainerClass: "",
                    controlWrapper: "",
                    arrowHeight: "100"
                };
                var options = $.extend(true, {}, defaults, options);
                var wrapper = $("." + options.sliderContainerClass);
                wrapper.each(function () {
                    var $that = $(this);
                    var container = $that.find("." + options.assetContainerClass).first();
                    if (container.length < 1) {
                        return;
                    }
                    if (container.find('.gallery').length > 0) {
                        container.find('img').first().load(function () {
                            setArrowPosition($that, container);
                        });
                    } else {
                        setArrowPosition($that, container);
                    }
                });

                function setArrowPosition($that, container) {
                    var containerHeight = container.outerHeight();
                    var arrowTopPos = Math.abs(containerHeight / 2 - options.arrowHeight / 2);
                    $that.find("." + options.controlWrapper + ' a').css('height', containerHeight + 'px');
                    $that.find("." + options.controlWrapper + 'a:after').css("top", arrowTopPos);
                }
            },
            centerVertically: function (parentElem, childElem, minTop, test) {
                if (timer) {
                    return;
                }
                if (parentElem.hasClass("asset-gallery-lightbox")) {
                    var parentElemWidth = parentElem.find(".rg-gallery").width();
                    parentElem.css("width", parentElemWidth);
//alert(parentElem.css("width"));
                }
                if (!dObj.centerVertically) {
                    childElem.css("top", 0);
                    return;
                }
                dObj.centerVertically = false;
                var timer = setTimeout(function () {
                    minTop = (minTop) ? minTop : 0;
                    var parentHeight = parentElem.outerHeight();
                    var childHeight = childElem.outerHeight();
                    var childWidth = childElem.outerWidth();
                    var pageHeight = $(window).height();
                    var pageWidth = $(window).width();
                    if (childHeight === 0) {
                        return;
                    }
                    childElem.css("top", function () {
                        var topPos = Math.abs(parentHeight / 2 - childHeight / 2);
// change: header is no longer important for top position
//topPos = (topPos > minTop) ? Math.abs(parentHeight / 2 - childHeight / 2) : minTop + 10;
//alert (childElem + " | " + topPos + " | " + childHeight + " | " + pageHeight );
                        if (topPos + childHeight >= pageHeight) {
                            topPos = 0;
                            if (parentElem.hasClass("asset-gallery-lightbox")) {
                                if (childHeight > pageHeight) {
                                    var percentage = pageHeight / childHeight;
                                    var newWidth = Math.floor(parseInt(parentElem.css("width"), 10) * percentage);
                                    parentElem.css("width", newWidth + "px");
//alert("1: " + newWidth);
                                }
                            }
                        } else {
                            if (dObj.breakpoint === "breakpoint-xs") {
                                if (parentElem.hasClass("asset-gallery-lightbox")) {
                                    var parentElemWidth = parentElem.find(".rg-gallery").width();
                                    parentElem.css("width", function () {
                                        if (childWidth > pageWidth) {
                                            return "100%";
                                        } else if (childWidth < pageWidth) {
                                            var percentage = pageHeight / childHeight;
                                            var newWidth = Math.floor(parseInt(parentElem.css("width"), 10) * percentage);
                                            parentElem.css("width", newWidth + "px");
                                        } else {
                                            return parentElemWidth
                                        }
//return (dObj.breakpoint !== "breakpoint-xs") ? parentElemWidth : "100%";
                                    });
                                    /*parentElem.css("width", function(){
return (dObj.breakpoint !== "breakpoint-xs") ? parentElemWidth : "100%";
});*/
//alert("width: " + parentElemWidth + " | " + dObj.breakpoint);
                                }
                            }
//alert("2");
                        }
                        return (topPos > 0) ? topPos + "px" : 0;
                    });
                }, 50);
            },
            equalheight: function (container) {
                var currentTallest = 0,
                    currentRowStart = 0,
                    rowDivs = new Array(),
                    $el,
                    topPosition = 0;
                $(container).each(function () {
                    $el = $(this);
                    $el.height('auto');
                    topPosition = $el.position().top;
                    if (currentRowStart != topPosition) {
                        for (var currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
                            rowDivs[currentDiv].height(currentTallest);
                        }
                        rowDivs.length = 0; // empty the array
                        currentRowStart = topPosition;
                        currentTallest = $el.height();
                        rowDivs.push($el);
                    } else {
                        rowDivs.push($el);
                        currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
                    }
                    for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
                        rowDivs[currentDiv].height(currentTallest);
                    }
                });
            },
            counter: 0,
            resizeCallback: function () {
                var counter = dObj.helpers.counter;
                var breakpoint = dObj.helpers.getBreakpoint();
// set marker: page has been resized
                dObj.resized = true;
// if (breakpoint !== dObj.breakpointWas){
                onBreakpointChange();
//console.log("resize nr: " + counter);
                dObj.helpers.counter++;
// dObj.breakpointWas = dObj.breakpoint;
// }
                $.event.trigger({
                    type: "windowScroll",
                    message: "window has scrolled.",
                    offset: $(window).pageYOffset
                });
            },
            isMobile: function () {
                var check = false;
                (function (a) {
                    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
                })(navigator.userAgent || navigator.vendor || window.opera);
                return check;
            },
            isRetina: function () {
                return window.devicePixelRatio > 1;
            },
            formatNr: function (nrStr) {
                var langModifier = LANG.code ? LANG.code : 'de';
                var formattedNr = new Intl.NumberFormat(langModifier).format(nrStr);
                return formattedNr;
            }
        }
    };

    var init = function () {

        var $grid_wrapper = $('.grid-wrapper');
        if ($grid_wrapper.length === 0) {
            return;
        }

        initGrid($grid_wrapper);

        // grid  = new Isotope('.home_grid', {
        //     itemSelector: '.home_grid__item',
        //     // layoutMode: 'fitRows'
        //     layoutMode: 'packery',
        //     percentPosition: true,
        //     masonry: {
        //         columnWidth: '.home_grid__grid-sizer'
        //     }
        // });
        //
        // var imgLoad = imagesLoaded('.home_grid');
        // imgLoad.on('progress', function(instance) {
        //     grid.layout();
        // });
    };

    var initGrid = function(teaserGrid) {

        teaserGrid.on('layoutComplete', function (event) {
            console.log('layoutComplete');
            // initMobileLayout(event.target.id);
            // checkJobsGridLayout(teaserGrid);
        });

        var imgLoadCount = 0;
        var $gridImgs = teaserGrid.find('img');
        var gridImgCount = $gridImgs.length;

        // teaserGrid.isotope({
        isoGrid = new Isotope('.grid-wrapper', {
            itemSelector: '.grid-elem',
            layoutMode: 'masonry',
            percentPosition: true,
            masonry: {
                columnWidth: '.grid-column-sizer', //40,
                columnHeight: '.grid-column-sizer',
                gutter: 0
            },
            sortBy: 'first', //'random',
            sortAscending: true
        });

        // $gridImgs
        //     .each(function () {
        //         $(this)
        //             .one('load', function () {
        //                 imgLoadCount++;
        //                 if (imgLoadCount === gridImgCount) {
        //                     // all grid imgs are loaded at this point, grid can be initialized
        //                     // re-init layout on XS Viewport to ensure correct size of grid elements
        //                     if ($(window).width() < dObj.breakpointSM) {
        //                         // teaserGrid.isotope('layout');
        //                         grid.layout();
        //                     }
        //
        //                     grid.layout();
        //                 }
        //             })
        //             .each(function () {
        //                 if (this.complete) {
        //                     $(this).trigger('load');
        //                 }
        //             });
        // });

        var timeout = null;

        var imgLoad = imagesLoaded('.grid-wrapper');
        imgLoad.on('progress', function(instance) {
            console.log('onProgress');
            isoGrid.layout();

            var timeout = setTimeout(function() {
                isoGrid.layout();
            }, 100);
        });

        $(window).on('resize', function() {
            isoGrid.layout();
        });
    };
    
    return {
        init: init
    };
});